import { useIntl } from 'react-intl';

import BreadCrumb from '../../../components/BreadCrumb';
import useMarkdownFile from '../../../hooks/useMarkdownFile';
import bareMetalSpecificationDe from '../../../markdowns/BareMetal/specification.de.md';
import bareMetalSpecificationEn from '../../../markdowns/BareMetal/specification.md';
import SpecificationContent from '../SpecificationContent';

const BareMetalSpecification = () => {
  const intl = useIntl();
  const bareMetalSpecification =
    intl.locale === 'de' ? bareMetalSpecificationDe : bareMetalSpecificationEn;
  const { markdownContent } = useMarkdownFile(bareMetalSpecification);

  return (
    <SpecificationContent
      content={
        <>
          <BreadCrumb
            items={[
              {
                href: '/',
                text: intl.formatMessage({ id: 'title' }),
              },
              {
                href: '#',
                text: intl.formatMessage({ id: 'bareMetalProductSpecificationBreadcrumb' }),
              },
            ]}
          />
          {markdownContent}
        </>
      }
    />
  );
};

export default BareMetalSpecification;
